<template>
  <v-dialog
    :value="value"
    @input="$emit('input', $event)"
    max-width="900px"
    @afterLeave="tab = 0"
  >
    <v-card class="gray11" min-height="42rem">
      <v-card-text
        class="d-flex flex-column flex-md-row pa-1"
        style="height: 100%;"
      >
        <!-- RIGHT SIDE -->
        <div class="pa-5 rightSide">
          <div class="flex-1 d-flex align-start" style="gap: 20px;">
            <v-img
              :src="headerData.logoUrl"
              style="max-width: 40px;height: 40px"
              class="mt-1"
            />
            <div class="d-flex flex-column align-start justify-center">
              <div class="d-flex align-center justify-center" style="gap: 3px">
                <p class="font-Medium-18">{{ headerData.displayName }}</p>
                <p class="font-Medium-12">({{ headerData.coinUnit }})</p>
              </div>
              <p
                class="font-Medium-14 gray2--text text-truncate"
                style="width: 200px;"
              >
                {{ headerData.planDescription }}
              </p>
            </div>
          </div>
          <p class="mb-8 mt-5">
            {{
              $t(
                "staking.stakingPlans.dialogDetail.View_Complete_Plan_Information"
              )
            }}
          </p>
          <v-tabs
            v-model="tab"
            :vertical="!$vuetify.breakpoint.mdAndDown"
            background-color="transparent"
            active-class="active"
            class="not-active"
            hide-slider
            grow
          >
            <v-tab
              v-for="(item, index) in tabs"
              :key="index"
              class="font-Medium-14 d-flex align-center justify-start mb-4"
              style="gap: 8px"
            >
              <v-icon
                size="16"
                :clr="
                  index === tab
                    ? 'var(--v-primary-base)'
                    : 'var(--v-gray2-base)'
                "
                >{{ item.icon }}</v-icon
              >
              <span class="">{{ item.title }}</span>
            </v-tab>
          </v-tabs>
        </div>
        <!-- LEFT SIDE -->
        <div
          class="flex-grow-1 ma-2 pa-3 gray10 rounded-lg"
          style="min-height: 40rem"
        >
          <div class="d-flex align-center justify-space-between mb-8">
            <span class="font-Medium-18">{{ tabs[tab]["title"] }}</span>
            <v-btn icon @click="$emit('input', false)" class="gray11">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </div>
          <div v-if="tab === 0">
            <PlanInfo :headerData="headerData" />
          </div>
          <div v-if="tab === 1">
            <PlanSchedule />
          </div>
          <div v-if="tab === 2">
            <ContributionHistory
              :headerData="headerData"
              :renewalHistoryItems="renewalHistoryItems"
            />
          </div>
          <div v-if="tab === 3">
            <RewardTable :headerData="headerData" />
            <!--            <InviteFriends />-->
          </div>
        </div>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import PlanInfo from "@/components/Staking/MainPage/MyPlans/PlanDialog/PlanInfo.vue";
import PlanSchedule from "@/components/Staking/MainPage/MyPlans/PlanDialog/PlanSchedule.vue";
import RewardTable from "@/components/Staking/MainPage/MyPlans/PlanDialog/RewardTable.vue";

export default {
  components: {
    ContributionHistory: () =>
      import(
        "@/components/Staking/MainPage/MyPlans/PlanDialog/ContributionHistory.vue"
      ),
    RewardTable,
    PlanSchedule,
    PlanInfo
  },
  props: {
    value: Boolean,
    headerData: Object,
    renewalHistoryItems: Array
  },
  data() {
    return {
      tab: 0,
      tabs: [
        {
          title: this.$t("staking.stakingPlans.dialogDetail.Plan_Information"),
          icon: "$info"
        },
        {
          title: this.$t("staking.stakingPlans.dialogDetail.Plan_Timeline"),
          icon: "$timeline"
        },
        {
          title: this.$t(
            "staking.stakingPlans.dialogDetail.contributionHistory"
          ),
          icon: "$reward"
        },
        {
          title: this.$t("staking.stakingPlans.dialogDetail.Reward_Table"),
          icon: "$reward"
        }
        // {
        //   title: this.$t("staking.stakingPlans.dialogDetail.Invite_Friends"),
        //   icon: "mdi-account-multiple-plus"
        // }
      ]
    };
  }
};
</script>

<style scoped lang="scss">
.rightSide {
  width: 42rem;
  max-width: 300px;
  .active {
    background-color: var(--v-gray10-base);
    color: var(--v-gray1-base);
    border-radius: 8px;
  }
}

@media screen and (max-width: 962px) {
  .rightSide {
    max-width: 100%;
    .v-tab {
      padding: 16px !important;
    }
  }
}
</style>
